export function rangeFromSearchParams(searchParams) {
  const key = searchParams.get('range') ?? 'today';
  if (key !== 'custom') return { key };
  const from = searchParams.get('from');
  const to = searchParams.get('to');
  if (!from || !to) return { key: 'today' };
  return { key, from, to };
}

export function buildRangeQuery(range) {
  const parts = [`range=${encodeURIComponent(range.key)}`];
  if (range.key === 'custom') {
    parts.push(`from=${encodeURIComponent(range.from)}`, `to=${encodeURIComponent(range.to)}`);
  }
  return parts.join('&');
}
